// import { Component } from '@angular/core';
// import { RouterOutlet } from '@angular/router';

// @Component({
//   selector: 'app-root',
//   imports: [RouterOutlet],
//   templateUrl: './app.component.html',
//   styleUrl: './app.component.css'
// })
// export class AppComponent {
//   title = 'sales-admin';
// }
import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { HeaderComponent } from './shared/components/header/header.component';
import { SidebarComponent } from './shared/components/sidebar/sidebar.component';

import { Router,NavigationStart, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { MessageService } from 'primeng/api';
import { messaging } from './core/services/firebaseConfig.service';

import { environment } from '../environments/environment';
import { getToken, onMessage } from 'firebase/messaging';
import { DashboardNotificationService, NotificationDto, PagedNotificationsResponse } from './core/services/notification.service';
import { LoadingService } from './core/services/loading.service';
import { Observable } from 'rxjs';
import { AppLoaderComponent } from './features/app-loader/app-loader.component';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    SidebarComponent,
    HeaderComponent,
    CommonModule,
    ToastModule,
    AppLoaderComponent,
    CommonModule
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  notifications: NotificationDto[] = [];
  unreadCount = 0;

  title = 'worker-admin';

  showHeader = true;
  showSidebar = true;

  private lastRoute: string = '';
  loading$!: Observable<boolean>;
  constructor(private loadingService: LoadingService, private notificationService: DashboardNotificationService,private router: Router, private messageService: MessageService) {
     this.loading$ = this.loadingService.loading$;
    // Listen to route changes
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.showHeader = this.router.url !== '/auth/login';
        console.log(this.showHeader);

        ////////////////////to remove local storage///////////
        // const currentUrl = event.urlAfterRedirects;
        // if (
        //   this.lastRoute === '/task/create-task' &&
        //   currentUrl !== '/task/select-member' &&
        //   currentUrl !== '/task/apartments'
        // ) {
        //   console.log(
        //     'Navigated away from /create-task → clearing localStorage'
        //   );
        //   localStorage.removeItem('add-task-form');
        // }
        this.setupNavigationWatcher()
      });
  }



  setupNavigationWatcher() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        // ✅ احفظ المسار السابق قبل ما يبدل
        this.lastRoute = this.router.url;
      }

      if (event instanceof NavigationEnd) {
        const currentUrl = event.urlAfterRedirects;

        // ✅ المسار السابق هو صفحة الإنشاء
        const wasOnCreate = this.lastRoute.includes('/task/create-task');

        // ✅ انتقل إلى مسار جديد مش من الاستثناءات
        const isNotException =
          !currentUrl.includes('/task/select-member') &&
          !currentUrl.includes('/task/apartments');

        if (wasOnCreate && isNotException) {
          console.log('✅ Navigated away from create-task → clear localStorage');
          localStorage.removeItem('add-task-form');
        }
      }
    });
  }

  toggleSidebar() {
    this.showSidebar = !this.showSidebar; // Toggle sidebar visibility
  }
  // OnInit lifecycle hook
  ngOnInit(): void {
    console.log('AppComponent initialized!');
    this.checkScreenWidth();
    window.addEventListener('resize', this.checkScreenWidth.bind(this));

    this.requestPermission();
    this.listenToMessages();
    this.loadNotifications()
  }

  requestPermission() {
    Notification.requestPermission().then((permission) => {
      if (permission === 'granted') {
        getToken(messaging, {
          vapidKey: environment.firebase.vapidKey,
        }).then((currentToken) => {
          if (currentToken) {
            console.log('FCM Token:', currentToken);
          } else {
            console.warn('No registration token available.');
          }
        });
      }
    });
  }

  listenToMessages() {
    onMessage(messaging, (payload) => {
      console.log('Message received in foreground: ', payload);
      // alert(payload.notification?.title + ': ' + payload.notification?.body);
      this.messageService.add({
        severity: 'info',
        summary: payload.notification?.title || 'Notification',
        detail: payload.notification?.body || 'No message content',
        life: 5000,
      });

      this.playAudio();
    });
  }
  playAudio() {
    let audio = new Audio();
    audio.src = 'http://dev.studiflats.com/assets/bell.wav';

    let audio2: HTMLAudioElement = new Audio(
      'http://dev.studiflats.com/assets/bell.wav'
    );
    audio2.play();
  }

  // Check screen width and adjust sidebar visibility
  checkScreenWidth() {
    if (window.innerWidth < 992) {
      this.showSidebar = false; // Hide sidebar on small screens
    } else {
      this.showSidebar = true; // Show sidebar on large screens
    }
  }

    loadNotifications(): void {
    this.notificationService.getNotifications(1, 100).subscribe({
      next: (res: PagedNotificationsResponse) => {
        this.notifications = res.data || [];
        // لو عندك isRead استخدميه، لو لأ اعتبريهم كلهم unread دلوقتي
        this.unreadCount = this.notifications.length;

  //       this.unreadCount =5;


  //       this.notifications =  [
  //   {
  //     "id": "a1f5b890-12de-4f21-9a44-8b11dfa12f01",
  //     "sellerID": "7c21bc30-0083-49b4-9cb0-cf9831a9122a",
  //     "module": "Booking",
  //     "module_ID": "b1234567-0000-48d2-839c-11972cf120aa",
  //     "title": "New Booking Created",
  //     "message": "A new booking has been successfully created for Apartment A-12.",
  //     "created_At": "2025-12-09T10:31:29.116Z"
  //   },
  //   {
  //     "id": "b2d5f1e0-d52e-4f4a-92ef-51123ea88177",
  //     "sellerID": "7c21bc30-0083-49b4-9cb0-cf9831a9122a",
  //     "module": "Payment",
  //     "module_ID": "c9934572-2222-4211-9aa1-f1447224ca32",
  //     "title": "Payment Received",
  //     "message": "A payment of €450 has been received from John Doe.",
  //     "created_At": "2025-12-09T09:21:15.500Z"
  //   },
  //   {
  //     "id": "c3e8e8aa-124d-4cc2-bc44-7612fbbff551",
  //     "sellerID": "7c21bc30-0083-49b4-9cb0-cf9831a9122a",
  //     "module": "Task",
  //     "module_ID": "d7829100-4444-48f0-9d11-ccae124bc091",
  //     "title": "New Maintenance Request",
  //     "message": "A tenant submitted a new maintenance request for room 3A.",
  //     "created_At": "2025-12-09T08:04:52.000Z"
  //   },
  //   {
  //     "id": "d4a7c900-5521-4e9c-a22b-671121dd9931",
  //     "sellerID": "7c21bc30-0083-49b4-9cb0-cf9831a9122a",
  //     "module": "Offers",
  //     "module_ID": "e8890111-9999-4433-8fe1-cc22198fcd56",
  //     "title": "Offer Accepted",
  //     "message": "Your offer for Apartment B-21 has been accepted.",
  //     "created_At": "2025-12-09T07:50:11.230Z"
  //   },
  //   {
  //     "id": "e5bbf220-b8ab-4e44-b61a-a1b2b3c4d5e6",
  //     "sellerID": "7c21bc30-0083-49b4-9cb0-cf9831a9122a",
  //     "module": "System",
  //     "module_ID": "f1122334-abcd-42e8-9a22-c0eddeee1122",
  //     "title": "System Update",
  //     "message": "Dashboard performance has been improved in the latest update.",
  //     "created_At": "2025-12-08T22:15:00.000Z"
  //   }
  // ];


      },
      error: (err) => {
        console.error('Error loading notifications', err);
      }
    });
  }

   // مثال: لو الهيدر قالك إن فيه إشعار اتقرا
  onNotificationRead(id: string) {
    console.log(id)
    const idx = this.notifications.findIndex(n => n.id === id);
    if (idx !== -1) {
      this.unreadCount = Math.max(this.unreadCount - 1, 0);
      // هنا تقدري تبعتي API mark-as-read لو حبيتي
    }
    console.log('read')
  }

  ngOnDestroy() {
    // Remove the event listener to avoid memory leaks
    window.removeEventListener('resize', this.checkScreenWidth.bind(this));
  }
}
